export const config = {
    apiHost: process.env.REACT_APP_APIHOST, // 'localhost' || '195.178.51.91' || 'aisb.isb.rs' || 'dashboard_dev.aisb.hu' || 'dashboard.aisb.hu'
    apiPort: process.env.REACT_APP_APIPORT, // '4000'
    clientPort: process.env.REACT_APP_CLIENTPORT, // '3000'
}

export default config;



// WEBPACK FOOTER //
// ./src/config.js